import { render, staticRenderFns } from "./EmailTemplateCreator.vue?vue&type=template&id=ccdf5326&scoped=true&"
import script from "./EmailTemplateCreator.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateCreator.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateCreator.vue?vue&type=style&index=0&id=ccdf5326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdf5326",
  null
  
)

export default component.exports